import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { ALIGN } from 'gnos-tooltip'

import './style.scss'

export default class QuestionIcon extends Component {
    static propTypes = {
        align: PropTypes.string,
        character: PropTypes.string,
        color: PropTypes.string,
        id: PropTypes.string.isRequired,
        size: PropTypes.number,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        tooltipWidth: PropTypes.string,
    }

    static defaultProps = {
        align: ALIGN.CENTER,
        color: '#29abe2',
        character: '?',
        size: 12,
        text: '',
        tooltipWidth: 'auto',
    }

    render() {
        const { character, id, text, size, align, color, tooltipWidth } = this.props

        return (
            <Tooltip id={id} content={text} align={align} width={tooltipWidth}>
                <div
                    className={'question-icon'}
                    style={{
                        width: `${size}px`,
                        height: `${size}px`,
                        fontSize: `${size}px`,
                        borderColor: color,
                        color,
                    }}
                >
                    {character}
                </div>
            </Tooltip>
        )
    }
}
